import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BillingPackage } from "../interfaces/BillingPackages";
import {
  cancelBillingPackageApi,
  getBillingPackages,
  patchBillingPackage
} from "../api/billingPackages";
import { BillingPackageStatusType } from "../helpers/billingPackages";

const fetchBillingPackages = createAsyncThunk(
  "billingPackages/billingPackages",
  async (clientId?: number) => {
    const response = await getBillingPackages(clientId);
    return response;
  }
);

const updateBillingPackage = createAsyncThunk(
  "billingPackages/updateBillingPackage",
  async ({ data, id }: { data: BillingPackage; id: number }) => {
    const response = await patchBillingPackage(data, id);
    return response;
  }
);

const cancelBillingPackage = createAsyncThunk(
  "billingPackages/cancelBillingPackage",
  async (id: number) => {
    const response = await cancelBillingPackageApi(id);
    return response;
  }
);

interface State {
  collection: BillingPackage[];
  draft: BillingPackage | null;
}

const initialState: State = {
  collection: [],
  draft: null
};

const billingPackagesSlice = createSlice({
  name: "billingPackages",
  initialState,
  reducers: {
    clearBillingPackageDraft: (draft) => {
      draft.draft = null;
    },
    createBillingPackageDraft: (draft, action) => {
      draft.draft = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBillingPackages.fulfilled, (draft, { payload }) => {
      draft.collection = payload;
    });
    builder.addCase(updateBillingPackage.fulfilled, (draft, { payload }) => {
      const index = draft.collection.findIndex((item) => item.id === payload.id);
      if (index !== -1) {
        draft.collection[index] = payload;
      }
      draft.draft = null;
    });
    builder.addCase(cancelBillingPackage.fulfilled, (draft, { payload }) => {
      const index = draft.collection.findIndex((item) => item.id === payload.id);
      if (index !== -1) {
        draft.collection[index].status = BillingPackageStatusType.CANCELED;
      }
    });
  }
});

export default billingPackagesSlice.reducer;

export const { createBillingPackageDraft, clearBillingPackageDraft } = billingPackagesSlice.actions;

export { fetchBillingPackages, updateBillingPackage, cancelBillingPackage };
